import type { Vote } from '../../types';

export function groupVotesById(votes: Vote[]) {
  return votes.reduce<Record<string, Vote[]>>((acc, item) => {
    if (!acc[item.id]) {
      acc[item.id] = [];
    }

    acc[item.id].push(item);

    return acc;
  }, {});
}
